import { Icon, ICON_NAMES } from '@belong/ui-components/components/Icon';
import { MouseEventHandler, forwardRef } from 'react';
import { LIVE_CHAT_TEST_IDS } from '../../lib/testIds';
import { ButtonWrapper, TextPrompt, TheButton, StartChat, MessageIcon, UnreadCount } from './ChatButton.styles';
import CONTENT from '../content.json';

type ChatButtonProps = {
  onClick?: MouseEventHandler<HTMLElement>;
  visible?: boolean;
  unreadCount?: number;
};

export const ChatButton = forwardRef<any, ChatButtonProps>(({ onClick, unreadCount, visible }, ref) => {
  return (
    <ButtonWrapper visible={visible}>
      <TheButton
        ref={ref}
        onClick={onClick}
        title={CONTENT.ariaLabels.chatButton}
        id={LIVE_CHAT_TEST_IDS.OPEN_BUTTON}
        data-testid={LIVE_CHAT_TEST_IDS.OPEN_BUTTON}
      >
        <MessageIcon name={ICON_NAMES.MessagingInverse} />
        <TextPrompt>Chat</TextPrompt>
        <StartChat>
          <Icon name={ICON_NAMES.Messaging} />
        </StartChat>
      </TheButton>
      {unreadCount ? (
        <UnreadCount
          data-testid={LIVE_CHAT_TEST_IDS.UNREAD_COUNT}
          role="alert"
          aria-label={CONTENT.ariaLabels.unreadCount}
        >
          {unreadCount}
        </UnreadCount>
      ) : null}
    </ButtonWrapper>
  );
});

ChatButton.displayName = 'ChatButton';
